import React, { useMemo } from 'react';
import style from './index.module.scss';
import Input from '@lingxi-common-component/sirius-ui/Input';
import { Checkbox } from 'antd';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { getIn18Text } from 'api';
const EncryptMail = (props) => {
    const dispatch = useAppDispatch();
    const { currentMail } = useAppSelector(state => state.mailReducer);
    const showPw = useMemo(() => {
        return !!currentMail.savePassword;
    }, [currentMail]);
    const encpwd = useMemo(() => {
        var _a;
        return ((_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _a === void 0 ? void 0 : _a.encpwd) || '';
    }, [currentMail]);
    const savePwChange = e => {
        const { checked } = e.target;
        dispatch(mailActions.doChangeMailSavePassword(checked));
    };
    const changeEncpwd = (e) => {
        const { value } = e.target;
        dispatch(mailActions.doChangeMailEncpwd(value));
    };
    return (React.createElement("div", { className: style.encryptMail },
        React.createElement("p", { className: style.setPassword }, getIn18Text('SHEZHICHAKANMIM（SJRXYMMCNCKYJ）')),
        React.createElement("div", { className: `ant-allow-dark ${style.cont}` },
            React.createElement(Input, { className: style.enterPw, placeholder: getIn18Text('QINGSHURU6WEISZ、ZM、QFDXX'), maxLength: 16, allowClear: true, value: encpwd, onChange: e => changeEncpwd(e) }),
            React.createElement(Checkbox, { checked: showPw, className: style.savePwCheckbox, onChange: e => savePwChange(e) }, getIn18Text('ZAI【FAJIANXIANG】ZBCMM')))));
};
export default EncryptMail;
